import axios from "axios";

export const BASE_URL = "/api";//"http://localhost:5024/api";//"/api"; //process.env.SERVER_BASE_URL;
console.log("SERVER_BASE_URL",BASE_URL);
const $api = axios.create({
    withCredentials: false,
    baseURL: "/api"
});

export default $api;